// Client-side avatar placeholder (ARCHITECTURE.md: avatars deferred).
// Initials over a deterministic colour derived from a stable seed (the Circle
// ID, so a person keeps the same colour). No image is stored or transmitted.

export interface AvatarStyle {
  initials: string;
  bg: string;
  fg: string;
}

function hash(seed: string): number {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function initialsFrom(name: string, fallbackSeed: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
  if (parts.length === 1 && parts[0]!.length > 0) return parts[0]!.slice(0, 2).toUpperCase();
  return fallbackSeed.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase() || '?';
}

export function avatarFor(name: string, seed: string): AvatarStyle {
  const hue = hash(seed) % 360;
  return {
    initials: initialsFrom(name, seed),
    bg: `hsl(${hue} 55% 30%)`,
    fg: `hsl(${hue} 70% 88%)`,
  };
}
